// extracted by mini-css-extract-plugin
export var externalLink = "_e1-0";
export var internalLinkLabel = "_e1-1";